import { Box, TableRow, TableSortLabel } from "@mui/material";
import { useTranslation } from 'react-i18next'
import { CustomTableHead, HeaderCell } from "../../../../pages/styles";

export function TableHeader(props) {
    const { t } = useTranslation(); 
    const { order, orderBy, onRequestSort, headers } = props;
    const createSortHandler = (property, property2) => (event) => {
        onRequestSort(event, property, property2);
    };
  
    return (
        <CustomTableHead>
            <TableRow>
                {headers.map((headCell) => (
                    <HeaderCell
                        key={headCell.id}
                        align={headCell.center ? 'center' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        dataHead={headCell}
                    >
                    {headCell.sortArrow === true &&
                        <TableSortLabel
                            sx={{ width: 'max-content'}}
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id, headCell.customSort)}
                        >
                            {t(headCell.label) || headCell.label}
                            {orderBy === headCell.id ? 
                                (<Box component="span"> {order === 'desc' ? '' : ''} </Box>) 
                            : 
                                null
                            }
                        </TableSortLabel>
                    }
                    {headCell.sortArrow === false &&
                        <Box component="span" sx={{ width: 'max-content'}}>
                            {t(headCell.label) || headCell.label}
                        </Box>
                    }
                    </HeaderCell>
                ))}
            </TableRow>
        </CustomTableHead >
    );
}